module.exports = __webpack_public_path__ + "img/gg.453d95c7.svg";